<template>
    <b-select
        :expanded="expanded"
        v-model="options.type"
        @input="$emit('input')">
        <option value="*">Все пользователи</option>
        <option value="employee.*">Сотрудники</option>
        <option value="employee.teacher">&nbsp;Преподаватели</option>
        <option value="employee.associate">&nbsp;Администрация</option>
        <option value="student.*">Учащиеся</option>
        <option value="student.bachelor">&nbsp;Бакалавриат</option>
        <option value="student.master">&nbsp;Магистратура</option>
        <option value="student.graduate">&nbsp;Аспирантура</option>
    </b-select>
</template>

<script>
export default {
  props: {
    expanded: Boolean,
    options: Object
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/users/index/components/TypeSelect.vue